<template>
  <div class="container">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacion" titulo="Afegir usuari" icono="fa-solid fa-plus" :loading="loading.creacion" @abrir="abrirModal('autofocusCreacion')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion" autocomplete="off" @submit.prevent="crear">
              <div class="form-group">
                <label for="nuevo-nom">Nom</label>
                <input ref="autofocusCreacion" type="text" class="form-control" id="nuevo-nom" v-model="nuevos.usuario.nom" :disabled="loading.creacion" maxlength="255" required />
              </div>
              <div class="form-group">
                <label for="nuevo-cognoms">Cognoms</label>
                <input type="text" class="form-control" id="nuevo-cognoms" v-model="nuevos.usuario.cognoms" :disabled="loading.creacion" maxlength="255" />
              </div>
              <div class="form-group">
                <label for="nuevo-email">Email</label>
                <input type="email" class="form-control" id="nuevo-email" v-model="nuevos.usuario.email" :disabled="loading.creacion" maxlength="320" required />
              </div>
              <div class="form-group">
                <label for="nuevo-clau">Clau</label>
                <div class="input-group">
                  <input :type="claveVisible ? 'text' : 'password'" class="form-control" id="nuevo-clau" v-model="nuevos.usuario.clau" :disabled="loading.creacion" autocomplete="new-password" required />
                  <div class="input-group-append">
                    <span class="input-group-text" role="button" @click="claveVisible = !claveVisible" title="Canviar visibilitat informació sensible" v-tooltip><i class="fa-solid" :class="claveVisible ? 'fa-eye-slash' : 'fa-eye'"></i></span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-rol">Rol</label>
                <select class="form-control" id="nuevo-rol" v-model="nuevos.usuario.rol" :disabled="loading.creacion" required>
                  <option v-for="(rol, index) in roles" :key="index">{{ rol }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-id_treballador">Treballador</label>
                <select class="form-control" id="nuevo-id_treballador" v-model="nuevos.usuario.id_treballador" :disabled="loading.creacion">
                  <option value=""></option>
                  <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-coaching">Email a l'app Coaching</label>
                <input type="email" class="form-control" id="nuevo-coaching" v-model="nuevos.usuario.email_coaching" :disabled="loading.creacion" maxlength="320" />
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion" :disabled="loading.creacion"><i-submit icono="fa-plus" :loading="loading.creacion" />Confirmar</button>
          </template>
        </modal>
      </li>
    </ul>
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap usuari</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar usuari" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar usuari" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar usuari" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="custom-control custom-switch mb-3">
                  <input type="checkbox" class="custom-control-input" :id="`actiu${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).es_actiu" :disabled="loading.edicion" />
                  <label class="custom-control-label" :for="`actiu${props.row.id}`">Actiu</label>
                </div>
                <div class="form-group">
                  <label :for="`nom${props.row.id}`">Nom</label>
                  <input :ref="`autofocusEdicion${props.row.id}`" type="text" class="form-control" :id="`nom${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).nom" :disabled="loading.edicion" maxlength="255" required />
                </div>
                <div class="form-group">
                  <label :for="`cognoms${props.row.id}`">Cognoms</label>
                  <input type="text" class="form-control" :id="`cognoms${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).cognoms" :disabled="loading.edicion" maxlength="255" />
                </div>
                <div class="form-group">
                  <label :for="`email${props.row.id}`">Email</label>
                  <input type="email" class="form-control" :id="`email${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).email" :disabled="loading.edicion" maxlength="320" required />
                </div>
                <div class="form-group">
                  <label :for="`clau${props.row.id}`">Clau</label>
                  <div class="input-group">
                    <input :type="claveVisible ? 'text' : 'password'" class="form-control" :id="`clau${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).clau" :disabled="loading.edicion" autocomplete="new-password" aria-describedby="password-help" />
                    <div class="input-group-append">
                      <span class="input-group-text" role="button" @click="claveVisible = !claveVisible" title="Canviar visibilitat informació sensible" v-tooltip><i class="fa-solid" :class="claveVisible ? 'fa-eye-slash' : 'fa-eye'"></i></span>
                    </div>
                  </div>
                  <small id="password-help" class="form-text text-muted">Si no cal canviar la clau, deixa el camp buit.</small>
                </div>
                <div class="form-group">
                  <label :for="`rol${props.row.id}`">Rol</label>
                  <select class="form-control" :id="`rol${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).rol" :disabled="loading.edicion" required>
                    <option v-for="(rol, index) in roles" :key="index">{{ rol }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`id_treballador${props.row.id}`">Treballador</label>
                  <select class="form-control" :id="`id_treballador${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).id_treballador" :disabled="loading.edicion">
                    <option value=""></option>
                    <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`coaching${props.row.id}`">Email a l'app Coaching</label>
                  <input type="email" class="form-control" :id="`coaching${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).email_coaching" :disabled="loading.edicion" maxlength="320" />
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`"><i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar</button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar usuari" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar a <b>{{ props.row.nombre_completo }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="rol" slot-scope="props">
        <span class="badge badge-primary">{{ props.cell_value }}</span>
      </template>
      <template slot="es_actiu" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-circle-check"></i>
      </template>
      <template slot="coaching_status" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-circle-check"></i>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss"></style>

<script>
export default {
  name: "Usuaris",
  inject: ["exportarTabla", "exportarBolcat", "actionsExportar"],
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Actiu",
          name: "es_actiu",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra estat",
            options: [
              {
                name: "Actiu",
                value: 1,
              },
              {
                name: "Inactiu",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "es_actiu",
        },
        {
          label: "Nom complet",
          name: "nombre_completo",
          filter: {
            type: "simple",
            placeholder: "Filtra nom",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Rol",
          name: "rol",
          filter: {
            type: "simple",
            placeholder: "Filtra rol",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Treballador",
          name: "trabajador",
          filter: {
            type: "simple",
            placeholder: "Filtra treballador",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Coaching",
          name: "coaching_status",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra coaching",
            options: [
              {
                name: "Amb accés",
                value: true,
              },
              {
                name: "Sense accés",
                value: false,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "coaching_status",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Tots els usuaris",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        usuario: {
          nom: null,
          cognoms: null,
          email: null,
          clau: null,
          rol: null,
          id_treballador: null,
          email_coaching: null,
        },
      },
      roles: [],
      trabajadores: [],
      claveVisible: false,
    };
  },
  methods: {
    getData: function () {
      this.$http.get("api/usuaris").then((response) => {
        this.rows = response.data;
      });

      this.$http.get("api/usuaris?valores=rol").then((response) => {
        this.roles = response.data;
      });

      this.$http.get("api/treballadors?activos&order=nom").then((response) => (this.trabajadores = response.data));
    },
    getRowId: function (id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    crear: function () {
      this.loading.creacion = true;

      this.$http
        .post("api/usuaris", this.nuevos.usuario)
        .then((response) => {
          this.loading.creacion = false;

          this.$nextTick(function () {
            if (response.status == 201) {
              this.rows.push(response.data);

              this.$refs.modalCreacion.cerrar();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Usuari afegit correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacion = false;
        });
    },
    editar: function (id) {
      this.loading.edicion = true;

      this.$http
        .put(`api/usuaris/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(function () {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();
              this.getRowId(id, this.rowsBuffer).nombre_completo = response.data.nombre_completo;
              this.getRowId(id, this.rowsBuffer).trabajador = response.data.trabajador;
              this.getRowId(id, this.rowsBuffer).clau = null;

              this.rows = structuredClone(this.rowsBuffer);

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Usuari editat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/usuaris/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Usuari eliminat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    cerrarCreacion: function () {
      this.nuevos.usuario.nom = null;
      this.nuevos.usuario.cognoms = null;
      this.nuevos.usuario.email = null;
      this.nuevos.usuario.clau = null;
      this.nuevos.usuario.rol = null;
      this.nuevos.usuario.id_treballador = null;
      this.nuevos.usuario.email_coaching = null;
      this.claveVisible = false;
    },
    cerrarEdicion: function () {
      this.rowsBuffer = structuredClone(this.rows);
      this.claveVisible = false;
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>